import React, { ReactElement } from "react";

import {
    PersonalIntegrityLink,
    UpdateCookieConsent,
} from "components/Footer/Footer.styled";
import triggerUpdateCookieConsent from "utils/triggerUpdateCookieConsent";

import { BottomSection, Links, BottomContainer } from "./FooterSlim.styled";
import FooterSlimProps from "./FooterSlimProps";

export const FooterSlim = ({
    key,
    l18n,
    personalIntegrityLinks,
}: FooterSlimProps): ReactElement => {
    const onUpdateCookieConsentClick = (
        event: React.MouseEvent<HTMLButtonElement>,
    ): void => {
        event.preventDefault();
        triggerUpdateCookieConsent();
    };

    return (
        <div role="contentinfo">
            <BottomSection key={key} theme="blue" alignItems="center">
                <BottomContainer>
                    <Links key={`PersonalIntegrityLinks`}>
                        {personalIntegrityLinks ? (
                            personalIntegrityLinks.items?.map(
                                (navItem, index) => (
                                    <div key={`PersonalIntegrityLink-${index}`}>
                                        <PersonalIntegrityLink
                                            url={navItem.url}
                                            title={
                                                (navItem.properties
                                                    ?.title as string) ||
                                                navItem.displayName ||
                                                ""
                                            }
                                            hoverSpan={true}
                                        >
                                            <span>{navItem.displayName}</span>
                                        </PersonalIntegrityLink>
                                    </div>
                                ),
                            )
                        ) : (
                            <></>
                        )}
                        <UpdateCookieConsent
                            key={`UpdateCookieConsent`}
                            onClick={onUpdateCookieConsentClick}
                            title={l18n?.updateCookieConsent}
                        >
                            <span>
                                {l18n?.updateCookieConsent ||
                                    "Update cookie consent"}
                            </span>
                        </UpdateCookieConsent>
                    </Links>
                </BottomContainer>
            </BottomSection>
        </div>
    );
};

export default React.memo(FooterSlim);
